<template lang="pug">
	.section
		.wrapper
			block-categories
			.section__title(data-aos="fade-up") Хвороби
			.section__body
				.wrapper
					.section__select(data-aos="fade-up" data-aos-delay="200")
						block-select(:name="'Оберіть культуру'" :label="'name'" :options="getCulturesWithDiseases" @input="onChange" :selected="selectedCulture")
						block-select(:name="'Оберіть хворобу'" :label="'name'" :options="getCulturesWithDiseasesBySlug($route.params.slug) ? getCulturesWithDiseasesBySlug($route.params.slug).diseases : []" @input="onChangeDisease" :selected="page")
				content-card(:page="page")
</template>

<script>

  let collectionSlug = 'diseases_by_culture';

	import ListSection from '@/components/listSection.vue';

	import BlockSelect from '@/components/select.vue';
	import ContentCard from '@/components/contentCard.vue';
	import BlockCategories from '@/components/weedsCategories.vue';

	import AOS from 'aos';

	import {mapState, mapGetters} from 'vuex';

	export default {
		name: collectionSlug,
		metaInfo: function() {
			let th = this;

			return {
				title: 'Хвороби — ' + th.selectedCulture.name
			}
		},
		data: function(){
			return {
				page: {},
				selectedCulture: {}
			}
		},
		created() {
			
			this.check();

			if (!this[collectionSlug].length) this.$store.dispatch('GET_COLLECTION', collectionSlug);
			if (!this.products.length) this.$store.dispatch('GET_COLLECTION', 'products');
			if (!this.catalogs.length) this.$store.dispatch('GET_COLLECTION', 'catalogs');
			if (!this.catalogs.length) this.$store.dispatch('GET_COLLECTION', 'cultures');
		},
		mounted() {
			this.$nextTick(() => {
				AOS.init({
					once: true,
					disabled: 'mobile',
					duration: 1000
				});
			})
		},
		components: {
			'list-section': ListSection,
			'block-select': BlockSelect,
			'content-card': ContentCard,
			'block-categories': BlockCategories,
		},
		methods: {
			onChange(e) {
				let page = this.getCulturesWithDiseasesBySlug(this.$route.params.slug).diseases[0];
				page.full_products = this.getProductsByIds(page.products);
				page.full_cultures = this.getCulturesByDisease(page.id);
				this.page = page;
				this.$router.push({path: '/diseases/' + e.slug + '/'});
			},
			onChangeDisease(e) {
				this.page = {};
				setTimeout(() => {
					let page = e;
					page.full_products = this.getProductsByIds(page.products);
					page.full_cultures = this.getCulturesByDisease(page.id);
					this.page = page;
				});
			},
			check() {
				if (!this.$route.params.slug && this.diseases_by_culture.length) {
					this.$router.push({path: '/diseases/' + this.getCulturesWithDiseases[0].slug + '/'})
				}

				if (this.$route.params.slug && this.diseases_by_culture.length && this.products.length && this.catalogs.length && this.cultures.length) {
					let page = this.getCulturesWithDiseasesBySlug(this.$route.params.slug).diseases[0];
					page.full_products = this.getProductsByIds(page.products);
					page.full_cultures = this.getCulturesByDisease(page.id);
					this.page = page;
					this.selectedCulture = this.getCulturesWithDiseasesBySlug(this.$route.params.slug);
				}
			}
		},
		computed: {
			...mapState([
				collectionSlug,
				'products',
				'catalogs',
				'cultures',
			]),
			...mapGetters([
				'getCulturesWithDiseases',
				'getCulturesWithDiseasesBySlug',
				'getProductsByIds',
				'getCulturesByDisease'
			])
		},
		watch: {
			diseases_by_culture() {
				this.check();
			},
			products() {
				this.check();
			},
			catalogs() {
				this.check();
			},
			cultures() {
				this.check();
			}
		}
	}

</script>

<style lang="scss" scoped>

	@import '@/helpers/sass/kit.scss';

	.section {

		margin-top: 45px;

		&__title {
			@include kit('postTitle');
		}

		&__body {
			margin-top: 93px;

			.wrapper {
				max-width: 846px;
			}
		}

		&__select {
			text-align: center;
		}
	}

	@media screen and (max-width: 1200px) {
		.section {
			margin-bottom: 100px;
			
			&__title {
				margin-top: 50px;
			}

			&__body {
				margin-top: 30px;

				.wrapper {
					padding: 0;
				}
			}
		}
	}
</style>
